import { render, staticRenderFns } from "./DownloadCSV.vue?vue&type=template&id=fdd56de2"
import script from "./DownloadCSV.vue?vue&type=script&lang=js"
export * from "./DownloadCSV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports